import React, { useContext, useEffect } from "react";
const Message = React.lazy(() => import("semantic-ui-react").then((module) => ({ default: module.Message })));
//import { Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import Countdown from "react-countdown";
import { getExpiryDate, getRefreshToken } from "@/api/localStorage";
import { useNavigate } from "react-router-dom";
import AppContext from "@/App/context/AppContext";
import useUser from "@/shared/hooks/useUser";

// eslint-disable-next-line
const renderer = ({ minutes, seconds }: { minutes: any; seconds: any }) => {
  return `00:${`${minutes}`.padStart(2, "0")}:${`${seconds}`.padStart(2, "0")}`;
};

export function ImpersonateBanner() {
  const { impersonatorToken: impersonatedBy } = useContext(AppContext);
  const { setImpersonatorToken } = useContext(AppContext);

  useEffect(() => {
    if (!impersonatedBy) {
      setImpersonatorToken && setImpersonatorToken(localStorage.getItem("impersonator_token") ?? "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [impersonatedBy]);
  const { data: user } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleOnComplete = ({ completed }: { completed: boolean }) => {
    if (completed) {
      navigate("/logout");
    }
  };
  if (impersonatedBy) {
    return (
      <Message error size="huge" floating style={{ margin: 0 }}>
        {t("impersonate.banner", { name: user?.email ? `(${user?.email})` : "" })}
        <div style={{ float: "right" }}>
          {t("impersonate.sessionValid")}{" "}
          <Countdown date={getExpiryDate(getRefreshToken())} renderer={renderer} onComplete={handleOnComplete} />
        </div>
      </Message>
    );
  }

  return null;
}
